module.exports = __webpack_public_path__ + "img/preset1.e5d85c78.png";